import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How does the Board Bag Shipment service work?",
    a: "When airlines from Medan or Padang impose heavy luggage limits or high board fees, we arrange ground and ferry cargo transfer directly to Raffiel Nias reception. Fixed rates: IDR 1,300,000 per board bag from Medan (KNO) and IDR 1,600,000 per board bag from Padang (PDG). Fill out our form or WhatsApp us your flight itinerary.",
  },
  {
    q: "What are the monthly stay rates for remote workers?",
    a: "Monthly long-stay rooms start from $700 per month, which includes reliable WiFi, hot shower access, daily housekeeping, mini gym, and pool facilities.",
  },
  {
    q: "How do I book direct?",
    a: "You can instantly reserve your room through our official GuestPro booking engine link or chat directly with our team on WhatsApp for custom group and family packages.",
  },
];

const Faq = () => (
  <section id="faq" className="py-20 bg-sand-100 border-y border-sand-200" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-6">
      <div className="text-center mb-12">
        <span className="text-xs font-mono-clean text-ocean-700 uppercase tracking-wider font-semibold">
          Questions & Details
        </span>
        <h2 className="font-display text-3xl font-bold text-ocean-900 mt-2">
          Frequently Asked Questions
        </h2>
      </div>
      <Accordion type="single" collapsible className="space-y-4">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`faq-${i}`}
            data-testid={`faq-item-${i}`}
            className="p-6 rounded-xl bg-sand-50 border border-sand-200"
          >
            <AccordionTrigger className="font-display font-bold text-ocean-900 text-base text-left hover:no-underline py-0">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-xs text-fog mt-2 leading-relaxed pb-0">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default Faq;
